import { render } from "./XcxIndex.vue?vue&type=template&id=631ddf96&scoped=true"
import script from "./XcxIndex.vue?vue&type=script&lang=js"
export * from "./XcxIndex.vue?vue&type=script&lang=js"

import "./XcxIndex.vue?vue&type=style&index=0&id=631ddf96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631ddf96"]])

export default __exports__